import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-software-upgrade",
  "use": "icon-software-upgrade-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-software-upgrade\"><path d=\"M520.418228 163.91421 256.571005 429.632037l164.898631 0 0 265.744433 197.912535 0L619.382171 429.632037l164.886351 0L520.418228 163.91421zM190.595384 811.640428l642.807185 0 0 48.445362L190.595384 860.08579 190.595384 811.640428z\" p-id=\"18661\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/software-upgrade.svg
// module id = b5Gq
// module chunks = 382